
import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Button from '../base/Button';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handlePricingClick = () => {
    if (location.pathname !== '/') {
      // If not on home page, navigate to home and then scroll
      navigate('/');
      setTimeout(() => {
        scrollToSection('pricing');
      }, 100);
    } else {
      // If on home page, just scroll
      scrollToSection('pricing');
    }
  };

  return (
    <>
      <header className="bg-white shadow-sm sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            {/* Logo */}
            <div className="flex-shrink-0">
              <a href="/" className="flex items-center cursor-pointer">
                <img 
                  src="https://static.readdy.ai/image/8afb2a5de69c924b4acd588d4e3deb2e/2263835a614b904a2284171294cf6050.png" 
                  alt="Cofunnels"
                  className="h-10 w-auto"
                />
              </a>
            </div>

            {/* Desktop Navigation */}
            <div className="hidden md:flex items-center space-x-8">
              <a href="/" className="text-gray-700 hover:text-blue-600 font-medium transition-colors cursor-pointer">Home</a>
              <a href="/about" className="text-gray-700 hover:text-blue-600 font-medium transition-colors cursor-pointer">About</a>
              <a href="#services" className="text-gray-700 hover:text-blue-600 font-medium transition-colors cursor-pointer">Services</a>
              <button 
                onClick={handlePricingClick}
                className="text-gray-700 hover:text-blue-600 font-medium transition-colors cursor-pointer"
              >
                Pricing
              </button>
              <a href="/blog" className="text-gray-700 hover:text-blue-600 font-medium transition-colors cursor-pointer">Blog</a>
              <a href="/contact" className="text-gray-700 hover:text-blue-600 font-medium transition-colors cursor-pointer">Contact</a>
            </div>

            {/* CTA Buttons */}
            <div className="hidden md:flex items-center space-x-4">
              <a 
                href="tel:+17372527530"
                className="bg-green-600 hover:bg-green-700 text-white px-6 py-3 rounded-lg font-medium transition-colors duration-200 flex items-center cursor-pointer whitespace-nowrap text-base"
              >
                <i className="ri-phone-line mr-2"></i>
                Call 24/7
              </a>
              <button 
                onClick={() => scrollToSection('pricing')}
                className="cursor-pointer"
              >
                <Button variant="primary" className="whitespace-nowrap">
                  <i className="ri-rocket-line mr-2"></i>
                  Get Started
                </Button>
              </button>
            </div>

            {/* Mobile menu button */}
            <div className="md:hidden">
              <button
                onClick={toggleMenu}
                className="text-gray-700 hover:text-blue-600 p-2 cursor-pointer"
              >
                <i className={`${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
              </button>
            </div>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden bg-white border-t border-gray-200">
            <div className="px-2 pt-2 pb-3 space-y-1">
              <a href="/" className="block px-3 py-2 text-gray-700 hover:text-blue-600 text-sm font-medium transition-colors cursor-pointer">
                Home
              </a>
              <a href="/about" className="block px-3 py-2 text-gray-700 hover:text-blue-600 text-sm font-medium transition-colors cursor-pointer">
                About
              </a>
              <a href="#services" className="block px-3 py-2 text-gray-700 hover:text-blue-600 text-sm font-medium transition-colors cursor-pointer">
                Services
              </a>
              <button 
                onClick={() => {
                  handlePricingClick();
                  setIsMenuOpen(false);
                }}
                className="block px-3 py-2 text-gray-700 hover:text-blue-600 text-sm font-medium transition-colors cursor-pointer w-full text-left"
              >
                Pricing
              </button>
              <a href="/blog" className="block px-3 py-2 text-gray-700 hover:text-blue-600 text-sm font-medium transition-colors cursor-pointer">
                Blog
              </a>
              <a href="#contact" className="block px-3 py-2 text-gray-700 hover:text-blue-600 text-sm font-medium transition-colors cursor-pointer">
                Contact
              </a>
              <div className="px-3 py-2 space-y-2">
                <a 
                  href="tel:+17372527530"
                  className="block w-full bg-green-600 hover:bg-green-700 text-white px-6 py-3 rounded-lg font-medium transition-colors duration-200 text-center cursor-pointer whitespace-nowrap text-base"
                >
                  <i className="ri-phone-line mr-2"></i>
                  Call 24/7
                </a>
                <button 
                  onClick={() => {
                    scrollToSection('pricing');
                    setIsMenuOpen(false);
                  }}
                  className="cursor-pointer w-full"
                >
                  <Button variant="primary" size="sm" className="w-full whitespace-nowrap">
                    <i className="ri-rocket-line mr-2"></i>
                    Get Started
                  </Button>
                </button>
              </div>
            </div>
          </div>
        )}
      </header>
    </>
  );
}
